// This icon file is generated automatically.
var PtoCirCloseCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16 2a14 14 0 100 28 14 14 0 000-28zm5.17 19.32l-2.06-.01L16 17.6l-3.1 3.7h-2.07a.25.25 0 01-.25-.24c0-.06.02-.12.06-.17l4.07-4.84-4.07-4.84a.25.25 0 01.2-.41h2.06l3.1 3.7 3.1-3.7h2.07c.13 0 .25.1.25.25 0 .06-.03.12-.06.16l-4.06 4.84 4.06 4.85c.04.04.06.1.06.16 0 .14-.11.25-.25.25z", "fill-rule": "nonzero" } }] }, "name": "pto-cir-close-circle", "theme": "filled" };
export default PtoCirCloseCircleFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoCirCloseCircleFilled.js
// module id = 3884
// module chunks = 0